import { render, staticRenderFns } from "./DropdownTags.vue?vue&type=template&id=db825b98&"
import script from "./DropdownTags.vue?vue&type=script&lang=js&"
export * from "./DropdownTags.vue?vue&type=script&lang=js&"
import style0 from "./DropdownTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports